import { configureStore } from '@reduxjs/toolkit';
import { lettersApi } from '../features/letters/api';
import { authApi } from '../features/auth/api';
import { profilesApi } from '../features/profiles/api';
import { relationshipsApi } from '../features/relationships/api';
import { mailApi } from '../features/mail/api';
import { inviteLinksApi } from '../features/inviteLinks/api';
import { notificationsApi } from '../features/notifications/api';
import { adminApi } from '../features/admin/api';
import { appSettingsApi } from '../features/settings/api';
import drafts from '../features/drafts/draftsSlice';
import offline from '../features/offline/sealQueueSlice';
import hidden from '../features/hidden/hiddenSlice';

export const store = configureStore({
  reducer: {
    drafts,
    offline,
    hidden,
    [lettersApi.reducerPath]: lettersApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [profilesApi.reducerPath]: profilesApi.reducer,
    [relationshipsApi.reducerPath]: relationshipsApi.reducer,
    [mailApi.reducerPath]: mailApi.reducer,
    [inviteLinksApi.reducerPath]: inviteLinksApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [appSettingsApi.reducerPath]: appSettingsApi.reducer,
  },
  middleware: (getDefault) =>
    getDefault().concat(
      lettersApi.middleware,
      authApi.middleware,
      profilesApi.middleware,
      relationshipsApi.middleware,
      mailApi.middleware,
      inviteLinksApi.middleware,
      notificationsApi.middleware,
      adminApi.middleware,
      appSettingsApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;